import { searchCategories } from 'shared/constants/searchCategories';
import { ratingTypes } from 'shared/constants/ratingTypes';

export const buildCountryFilter = (regions, countries) => {
  const countryFilters = countries.reduce((all, item) => {
    const countryItem = regions.find(({ value }) => value === item);
    if (!countryItem) {
      return all;
    }

    return [
      ...all,
      {
        name: countryItem.name,
        iso: countryItem.iso,
        continent: countryItem.continent,
        continentCode: countryItem.continentCode,
      },
    ];
  }, []);
  return countryFilters;
};

export const getInitialSearchResultsModalFilters = (
  ratingType = ratingTypes.CREDIT_RATING,
  queryParams,
  regions,
  industries,
) => {
  const { country, industry, ...restFilters } = queryParams;

  return Object.keys({ country, industry, ...restFilters }).reduce((filters, category) => {
    if (!category || !queryParams[category]) return filters;

    const values = queryParams[category];
    switch (category) {
      case searchCategories.COUNTRY: {
        const countryFilters = buildCountryFilter(regions, values);
        return countryFilters
          ? {
              ...filters,
              ...(ratingType !== ratingTypes.CREDIT_REVIEW ? { countries: countryFilters } : {}),
              ...(ratingType === ratingTypes.CREDIT_REVIEW ? { country: countryFilters[0] } : {}),
            }
          : filters;
      }
      case searchCategories.INDUSTRY: {
        const industryFilters = values.reduce((all, item) => {
          const industryItem = industries.find(({ value }) => value === item);

          if (!industryItem) {
            return all;
          }

          return [
            ...all,
            {
              code: industryItem.code,
              industryCode: industryItem.industryCode,
              name: industryItem.name,
              industryName: industryItem.industryName,
            },
          ];
        }, []);

        return industryFilters.length
          ? {
              ...filters,
              industries: industryFilters,
            }
          : filters;
      }
      default:
        return { ...filters, [category]: values };
    }
  }, {});
};

export const getInitialSearchResultsFilters = (
  ratingType,
  { industries, countries, country, ...restFilters },
) => ({
  ...(industries
    ? {
        industrySectors: industries.map(({ code, industryCode }) => ({
          sector: code,
          industry: industryCode,
        })),
      }
    : {}),
  ...(ratingType !== ratingTypes.CREDIT_REVIEW && countries
    ? { countries: countries.map(({ iso }) => iso) }
    : {}),
  ...(ratingType === ratingTypes.CREDIT_REVIEW && country ? { country: country.iso } : {}),
  ...(ratingType === ratingTypes.CREDIT_REVIEW ? restFilters : {}),
});
